// src/components/Sidebar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";

export default function Sidebar({ onToggle, isCollapsed }) {
  const [collapsed, setCollapsed] = useState(isCollapsed || false);

  const handleToggle = () => {
    const newState = !collapsed;
    setCollapsed(newState);
    if (onToggle) onToggle(newState);
  };

  return (
    <>
      <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
        <nav>
          <NavLink to="/">
            <span>📊</span> {!collapsed && "Dashboard"}
          </NavLink>
          <NavLink to="/drivers">
            <span>👤</span> {!collapsed && "Drivers"}
          </NavLink>
          <NavLink to="/trucks">
            <span>🚛</span> {!collapsed && "Trucks"}
          </NavLink>
          <NavLink to="/trailers">
            <span>📦</span> {!collapsed && "Trailers"}
          </NavLink>
          <NavLink to="/routes-planning">
            <span>🗺️</span> {!collapsed && "Routes"}
          </NavLink>
          <NavLink to="/trips">
            <span>✈️</span> {!collapsed && "Trips"}
          </NavLink>
          <NavLink to="/finance">
            <span>💰</span> {!collapsed && "Finance"}
          </NavLink>
          <NavLink to="/complaints">
            <span>⚠️</span> {!collapsed && "Complaints"}
          </NavLink>
          <NavLink to="/documents">
            <span>📄</span> {!collapsed && "Documents"}
          </NavLink>
          <NavLink to="/cost-templates">
            <span>📑</span> {!collapsed && "Cost Templates"}
          </NavLink>
        </nav>
      </div>
      {/* Floating toggle button at the intersection */}
      <button className="sidebar-float-toggle" onClick={handleToggle}>
        {collapsed ? "→" : "←"}
      </button>
    </>
  );
}